import ReactMarkdown, { Components, Options } from "react-markdown";
import gfm from "remark-gfm";
import remarkFrontmatter from "remark-frontmatter";
import rehypeRaw from "rehype-raw";
import rehypeSanitize, { defaultSchema } from "rehype-sanitize";
import { Suspense, lazy } from "react";
import cx from "classnames";

import styles from "./styles.module.css";

const SyntaxHighlighter = lazy(() => import("./SyntaxHighlighter"));

const renderers: Components = {
  code({ children, className }) {
    const match = /language-(\w+)/.exec(className || "");
    const code = (
      <code className={className} role="code">
        {children}
      </code>
    );

    if (!match) {
      return code;
    }

    return (
      <Suspense fallback={code}>
        <SyntaxHighlighter value={String(children).trim()} language={match ? match[1] : "plain"} />
      </Suspense>
    );
  },
};

const plugins = [gfm, remarkFrontmatter];

const sanitizeSchema = {
  ...defaultSchema,
  attributes: {
    ...defaultSchema.attributes,
    img: [...(defaultSchema.attributes?.img ?? []), "alt", "title", "width", "height"],
  },
};

const rehypePlugins: Options["rehypePlugins"] = [rehypeRaw, [rehypeSanitize, sanitizeSchema]];

type MarkdownGithubProps = {
  markup: string;
};

const MarkdownGithub = (props: MarkdownGithubProps) => (
  <section className={cx(styles.markdownBody, styles.markdownBodyHh)}>
    <ReactMarkdown remarkPlugins={plugins} rehypePlugins={rehypePlugins} components={renderers}>
      {props.markup}
    </ReactMarkdown>
  </section>
);

export default MarkdownGithub;
